/* ==========================================================================
   AELVITA WELLNESS — Bundle & Save calculator
   Any 2 products = 10% off (SAVE10) | All 3 = 20% off (BUNDLE20)
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-bundle]');
  if (!root) return;

  var items = Array.prototype.slice.call(root.querySelectorAll('.bundle-item'));
  var subtotalEl = root.querySelector('[data-bundle-subtotal]');
  var discountRow = root.querySelector('[data-bundle-discount-row]');
  var discountEl = root.querySelector('[data-bundle-discount]');
  var totalEl = root.querySelector('[data-bundle-total]');
  var strikeEl = root.querySelector('[data-bundle-strike]');
  var badgeEl = root.querySelector('[data-bundle-badge]');
  var codeWrap = root.querySelector('[data-bundle-code-wrap]');
  var codeEl = root.querySelector('[data-bundle-code]');
  var addBtn = root.querySelector('[data-bundle-add]');
  var countEl = root.querySelector('[data-bundle-count]');

  function fmt(v) { return '$' + v.toFixed(2); }

  function selected() {
    return items.filter(function (it) { return it.classList.contains('is-selected'); });
  }

  function update() {
    var sel = selected();
    var subtotal = sel.reduce(function (sum, it) {
      return sum + parseFloat(it.getAttribute('data-price'));
    }, 0);

    var rate = 0, code = '';
    if (sel.length >= 3) { rate = 0.20; code = 'BUNDLE20'; }
    else if (sel.length === 2) { rate = 0.10; code = 'SAVE10'; }

    var discount = subtotal * rate;
    var total = subtotal - discount;

    if (subtotalEl) subtotalEl.textContent = fmt(subtotal);
    if (countEl) countEl.textContent = sel.length;

    if (rate > 0) {
      if (discountRow) discountRow.style.display = 'flex';
      if (discountEl) discountEl.textContent = '-' + fmt(discount);
      if (strikeEl) { strikeEl.textContent = fmt(subtotal); strikeEl.style.display = 'inline'; }
      if (badgeEl) { badgeEl.style.display = 'inline-block'; badgeEl.textContent = '🎉 You save ' + fmt(discount) + ' (' + (rate * 100) + '% OFF)'; }
      if (codeWrap) codeWrap.style.display = 'block';
      if (codeEl) codeEl.textContent = code;
    } else {
      if (discountRow) discountRow.style.display = 'none';
      if (strikeEl) strikeEl.style.display = 'none';
      if (badgeEl) badgeEl.style.display = 'none';
      if (codeWrap) codeWrap.style.display = 'none';
    }

    if (totalEl) totalEl.textContent = fmt(total);

    if (addBtn) {
      if (sel.length === 0) {
        addBtn.disabled = true;
        addBtn.textContent = 'Select products to build your bundle';
      } else {
        addBtn.disabled = false;
        addBtn.textContent = 'Add ' + sel.length + (sel.length === 1 ? ' Item' : ' Items') + ' to Cart — ' + fmt(total);
      }
    }
  }

  items.forEach(function (it) {
    it.addEventListener('click', function () {
      it.classList.toggle('is-selected');
      update();
    });
  });

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var sel = selected();
      if (!sel.length) return;
      var itemsPayload = sel.map(function (it) {
        return { id: parseInt(it.getAttribute('data-variant-id'), 10), quantity: 1 };
      }).filter(function (i) { return !isNaN(i.id) && i.id > 0; });

      var applyCode = sel.length >= 3 ? 'BUNDLE20' : (sel.length === 2 ? 'SAVE10' : '');

      if (!itemsPayload.length) {
        // No live variant IDs (theme preview without products) — guide the user
        window.showToast && window.showToast('Bundle ready! Discount code: ' + (applyCode || 'n/a'));
        return;
      }

      addBtn.textContent = 'Adding bundle…';
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: itemsPayload })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          // Apply discount automatically via cart discount URL on checkout
          if (applyCode) {
            window.showToast && window.showToast('Bundle added! Code ' + applyCode + ' applied at checkout.');
          } else {
            window.showToast && window.showToast('Added to cart');
          }
          if (window.openCart) window.openCart();
          // Store code so checkout can auto-apply
          if (applyCode) { try { sessionStorage.setItem('aelvita_discount', applyCode); } catch (e) {} }
          update();
        })
        .catch(function () { window.showToast && window.showToast('Could not add bundle'); update(); });
    });
  }

  update();
})();
